export const registerServiceWorker = () => {
    const swUrl = `${process.env.REACT_APP_BASENAME}/serviceWorker.js`;

    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register(swUrl);
    }
};
